import styled from '@emotion/styled';
import { forwardRef, memo } from 'react';

import { css, scaledCss } from '~/css';

import Dots from './Dots';
import FeatureCard from './FeatureCard';
import RepeatContainer from './RepeatContainer';
import { CarouselProps } from './types';

const Container = styled('div')(css({}));

const PcCarousel = forwardRef<HTMLDivElement, CarouselProps>(
  (
    { items, currentIndex, setCurrentIndex, mode, goPrev, goNext, textSize = 'medium', onTransitionEnd },
    forwardedRef,
  ) => {
    return (
      <Container>
        <Dots
          mode={mode}
          textSize={textSize}
          items={items}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          goPrev={goPrev}
          goNext={goNext}
          arrows
        />
        <div css={{ position: 'relative' }}>
          <RepeatContainer
            ref={forwardedRef}
            currentIndex={currentIndex}
            onTransitionEnd={onTransitionEnd}
            panelSize={mode === 'landscape' ? '800px' : '440px'}
            css={scaledCss({
              padding: '2.5em 1em',
              height: mode === 'landscape' ? [560, '600px'] : [980, '980px'],
            })}
          >
            {items.map((item, index) => (
              <FeatureCard
                key={index}
                title={item.title}
                description={item.description}
                sharp={item.image.localFile.childImageSharp}
                mode={mode}
                active={index === currentIndex}
                fold={index !== currentIndex}
              />
            ))}
          </RepeatContainer>
          <div
            css={css({
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              pointerEvents: 'none',
              backgroundImage: 'linear-gradient(to right, white 0%, transparent 2%, transparent 98%, white 100%)',
            })}
          />
        </div>
      </Container>
    );
  },
);

export default memo(PcCarousel);
